import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { F8865SchM2K1SourcingComponent } from './components/f8865-sch-m2-k1-sourcing/f8865-sch-m2-k1-sourcing.component';
import {AppNgMaterialModule} from '../app-ng-material.module';
import {AppNgAppkitModule} from '../app-ng-appkit.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { SeparatorDirective } from './directives/separator.directive';
import { MatInputCommifiedDirective } from './directives/mat-input-commified.directive';
import { SplAllocComponent } from './components/spl-alloc/spl-alloc.component';
import {SixDigitDecimaNumberDirective} from "./directives/six-digit-decimal-number.directive";
import { SourcingAmountsComponent } from './components/sourcing-amounts/sourcing-amounts.component';
import { PartnershipDashboardComponent } from './components/partnership-dashboard/partnership-dashboard.component';
import {MatListModule} from '@angular/material/list';
import { DiagnosticDashboardModule } from '../diagnostic-dashboard/diagnostic-dashboard.module';
import { SharedComponentsModule } from "../shared/components/shared-components.module";
import { SharedDirectivesModule } from "../shared/_directives/shared-directives.module";
import { numberWithCommasPipe } from './components/partnership-dashboard/numbers-with-commas.component';
import { DfAssignEntityComponent } from './components/df-assign-entity/df-assign-entity.component';
import { Form1065M2Component } from './components/form1065-m2/form1065-m2.component';
import { FilterAnyPipe } from '../shared/pipes/filter-any.pipe';
import { BatchAllocateComponent } from './components/batchallocate/batchallocate.component';
import { ExtEntityMaintenanceComponent } from './components/ext-entity/ext-entity-maintenance.component';
import { OnlyDigitsDirective, OnlyDigitsStringDirective } from './directives/only-digits.directive';
import { F1125SchAComponent } from './components/f1125-sch-a/f1125-sch-a.component';
import { BatchOpenAmendedComponent } from './components/batch-open-amended/batch-open-amended.component';
import { ProjectDeleteModalComponent } from './components/project-delete-modal/project-delete-modal.component';
import { MarkAsReviewedComponent } from './components/mark-as-reviewed/mark-as-reviewed.component';
import { PshipCodeMastComponent } from './components/pship-code-mast/pship-code-mast.component';
import { PartnerMaintenanceComponent } from './components/partner-maintenance/partner-maintenance.component';
import { F1065SchCComponent } from './components/f1065-sch-c/f1065-sch-c.component';
import { F1065SchB2Component } from './components/f1065-sch-b2/f1065-sch-b2.component';
import { F1065PageOneComponent } from './components/f1065-page-one/f1065-page-one.component';
import { F1065PageOneService } from './components/f1065-page-one/f1065-page-one.service';
import { F1065SchKComponent } from './components/f1065-sch-k/f1065-sch-k.component';
import { F1065SchKService } from './components/f1065-sch-k/f1065-sch-k.service';
import { F1065SchK1Component } from './components/f1065-sch-k1/f1065-sch-k1.component';
import { F1065SchK1Service } from './components/f1065-sch-k1/f1065-sch-k1.service';
import { F1065SchM3Component } from './components/f1065-sch-m3/f1065-sch-m3.component';
import { F1065SchM3Service } from './components/f1065-sch-m3/f1065-sch-m3.service';
import { F1065SchBComponent } from './components/f1065-sch-b/f1065-sch-b.component';
import { F1065SchBService } from './components/f1065-sch-b/f1065-sch-b.service';
import { DefaultSourcingComponent } from './components/default_sourcing/default-sourcing.component';
import { ApprConfigComponent } from './components/appr-config/appr-config.component';
import { PartnershipSetupComponent } from './components/partnership-setup/partnership-setup.component';
import { PartnerAllocComponent } from './components/partner-alloc/partner-alloc.component';
import { PartnerAllocNewComponent } from './components/partner-alloc-new/partner-alloc-new.component';
import { FootNotesComponent } from './components/foot-notes/foot-notes.component';
import { FootNotesService } from './components/foot-notes/foot-notes.service';
import { CopyNoteDialogComponent } from './components/foot-notes/copy-note-dialog/copy-note-dialog.component';

@NgModule({
    declarations: [F8865SchM2K1SourcingComponent, 
        SeparatorDirective, 
        MatInputCommifiedDirective, 
        SplAllocComponent, 
        SixDigitDecimaNumberDirective, 
        SourcingAmountsComponent, 
        PartnershipDashboardComponent, 
        numberWithCommasPipe, 
        DfAssignEntityComponent, 
        Form1065M2Component,
        FilterAnyPipe,
        BatchAllocateComponent,
        ExtEntityMaintenanceComponent,
        OnlyDigitsDirective,
        OnlyDigitsStringDirective,
        BatchOpenAmendedComponent,
        ProjectDeleteModalComponent,
        MarkAsReviewedComponent,
        F1125SchAComponent,
        PshipCodeMastComponent,
        PartnerMaintenanceComponent,
        F1065SchCComponent,
        F1065SchB2Component,
        F1065PageOneComponent,
        F1065SchKComponent,
        F1065SchK1Component,
        F1065SchM3Component,
        F1065SchBComponent,
        DefaultSourcingComponent,
        ApprConfigComponent,
        PartnershipSetupComponent,
        PartnerAllocComponent,
        PartnerAllocNewComponent,
        FootNotesComponent,
        CopyNoteDialogComponent
    ],
    providers: [
        F1065PageOneService,
        F1065SchKService,
        F1065SchK1Service,
        F1065SchM3Service,
        F1065SchBService,
        FootNotesService
    ],
    exports: [
        SplAllocComponent,
        SourcingAmountsComponent,
        PartnershipDashboardComponent,
        F1125SchAComponent
    ],
    imports: [
        CommonModule,
        OverlayModule,
        AppNgMaterialModule,
        AppNgAppkitModule,
        FormsModule,
        MatListModule,
        DiagnosticDashboardModule,
        SharedComponentsModule,
        SharedDirectivesModule,
        ReactiveFormsModule],
    schemas: [NO_ERRORS_SCHEMA]
})
export class PartnershipModule { }
